import Jt808SetContinueDriveLimitPerDayModal from './jt808-set-continue-drive-limit-per-day-modal.vue'
export default Jt808SetContinueDriveLimitPerDayModal
